const searchList = [
    {
        symbol: 'DOGE',
        searchedBy: 'dogecoin doge',
        price: 0.24
    },
    {
        symbol: 'BTC',
        searchedBy: 'bitcoin btc',
        price: 40000
    },
    {
        symbol: 'SHIB',
        searchedBy: 'shiba token shib',
        price: 0.00023
    },
    {
        symbol: 'USDT',
        searchedBy: 'dollar usd',
        price: 1
    },
    {
        symbol: 'DGB',
        searchedBy: 'digicoin dgb',
        price: 0.05
    }
];

export default searchList;
